import $ from 'jquery'
global.$ = $
global.jQuery = $

import '../tsecb/main'
import '../tsecb/scrolling-nav'
import '../tsecb/jquery.easing.min'
import '../tsecb/jquery.magnific-popup.min'
import '../tsecb/slick.min'
import "stylesheets/tsecb"